import "./App.css";
import FeedbackForm from "./components/FeedbackForm";
// v0dev-test\src\App.css
function App(){
  return(
    <>
    <div className="app">
       <FeedbackForm/>
    </div>
    </>
  )
}
export default App;